import { TBColumn } from '../../interfaces/TableBits.interfaces';
const columns: TBColumn[] = [
    {
        id: "bussinesName",
        label: 'Nombre del candidato',
        align: 'left',
    },
    {
        id: "comment",
        label: 'Razón',
        align: 'left',
    },
];

export default columns;